import React from 'react';
import { getAssetPath } from '../../utils/assetPath';
import './OptionsPanel.scss';

const OptionsPanel: React.FC = () => {
    
  return (
    <div className='virtenzo-panel-wrap'>
    <div className="virtenzo-panel" id="virtenzo-panel"></div>
    </div>

  );
};

export default OptionsPanel;
